'use strict';

/* eslint-disable no-undef */

var processInclude = require('base/util');

var PLP_REVAMP_ENABLED = SitePreferences.PLP_REVAMP_ENABLED;
var PLP_REVAMP_FILTERS_ENABLED = SitePreferences.PLP_REVAMP_FILTERS_ENABLED;

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./product/quickView'));

    if (PLP_REVAMP_ENABLED && PLP_REVAMP_FILTERS_ENABLED) {
        processInclude(require('./search/filterSettingsRevamp'));
    } else {
        processInclude(require('./search/filterSettings'));
    }
});
